import { useHistory } from 'react-router-dom';
import hasMigrated from '../../../../../utils/routeMatcher';

/**
 * Returns the goTo function.
 * The goTo function is responsible for adding the search result to recent searches and navigating to it's path.
 * @returns {func}
 */
const useGoTo = () => {
  const { push } = useHistory();
  return ({ path }) => {
    if (hasMigrated(path)) {
      window.location.href = path;
    } else {
      push(path);
    }
  };
};

export default useGoTo;
